import { React, useState, useEffect, forwardRef } from 'react'
import { useHistory } from "react-router-dom";
import getCookie, { setTeacherCookie, teacherState } from "../../Atom";
import { Link } from 'react-router-dom'
import ScanDevice from '../ScanDevice/ScanDevice';
import EditFile from './EditFile/EditFile';
import DeleteFiles from './DeleteFile/DeleteFiles';
import MuiAlert from "@mui/material/Alert";
import Tooltip from '@mui/material/Tooltip';
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import ReactPaginate from 'react-paginate';
import "./LaunchtrakFlight.css";
import { getAllClassbyTeacher, getLaunchTrekData } from './api'
import Snackbar from '@mui/material/Snackbar';
import Group_299 from "../../assets/images/Group_299.png";
import Group_332 from "../../assets/images/Group_332.png";
import add from '../../assets/images/add.png'
import notFound from '../../assets/images/notFound.png'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import subject from '../../../modules/mySubject';

let readableStreamClosed;
let reader;
let port,
  textEncoder,
  writableStreamClosed,
  writer = -1;
let currentCommand = "";
let tempFileNames = [];
let filenames = [];
let startedDumpingFile = false;
let graphData = [];
let dumpedData = "";

let localData = "";
let valuesOfInterest = [];
const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function Launchtrakflights(props) {
  const history = useHistory();
  const [paged, setPaged] = useState(0)
  const [myUser, setmyUser] = useState(teacherState);
  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [fileId, setFileId] = useState("");
  const [fileNames, setFileNames] = useState([]);
  const [loading, setLoading] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState("");
  const [snackBarSeverity, setSnackBarSeverity] = useState("");
  const [snackBarShow, setSnackBarShow] = useState(false);
  const [allClasses, setallclasses] = useState([]);
  const [selectedClassIds, setSelectedClassIds] = useState([]);
  const [selectedClassNames, setSelectedClassNames] = useState([]);
  const [deviceInfo, setDeviceInfo] = useState([]);
  const [dense, setDense] = useState(false);
  const [noOfPages, setNoOfPages] = useState(0);
  const [currPage, setCurrPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(25);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('createdAt');
  const [selected, setSelected] = useState([]);
  const [serial, setSerial] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(pageLimit);
  const [scanLoading, setScanLoading] = useState(false);
  const [checkedFiles, setCheckedFiles] = useState([]);
  const [noFiles, setNoFiles] = useState(false);
  const [metaArr, setMetaArr] = useState([]);
  const [tempArray, setTempArray] = useState([]);
  let search = window.location.search;
  let params = new URLSearchParams(search);

  const feedBackMsg = (snackShow, snackSeverity, snackMessage) => {
    setSnackBarShow(snackShow);
    setSnackBarSeverity(snackSeverity);
    setSnackBarMessage(snackMessage);
  };
  const [metaData, setMetaData] = useState({
    name: "",
    pressure: 0,
    volumeOfWater: 0,
    volumeOfEngine: 0,
    nozzleSize: 0,
    rocketDryMass: 0,
    parachuteSize: 0,
    noParachut: false,
  })
  let [deviceData, setDeviceData] = useState([
    {
      name: "",
      pressure: 0,
      volumeOfWater: 0,
      volumeOfEngine: 0,
      nozzleSize: 0,
      rocketDryMass: 0,
      parachuteSize: 0,
      noParachut: false,
      decentSpeed: 0,
      topSpeed: 0,
      totalFlightTime: 0,
      apogeeAltitude: 0,
      apogeeTime: 0,
      coastTime: 0,
      classes: []
    },
  ]);

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - deviceInfo.length) : 0;
  const headCells = [

    {
      id: 'name',
      numeric: false,
      disablePadding: true,
      label: 'File Name',
      width: "125px"
    },
    {
      id: 'originalName',
      numeric: false,
      disablePadding: true,
      label: 'Original Name',
      width: "160px  "
    },
    {
      id: 'pressure',
      numeric: true,
      disablePadding: true,
      label: 'Pressure',
      width: "150px"
    },
    {
      id: 'volumeOfWater',
      numeric: true,
      disablePadding: true,
      label: 'VOW',
      width: "100px"
    },
    {
      id: 'volumeOfEngine',
      numeric: true,
      disablePadding: true,
      label: 'VOE',
      width: "100px"
    },
    {
      id: 'nozzleSize',
      numeric: true,
      disablePadding: true,
      label: 'Nozzle Size',
      width: "150px"
    },
    {
      id: 'rocketDryMass',
      numeric: false,
      disablePadding: true,
      label: 'RDM',
      width: "110px"
    },
    {
      id: 'parachuteSize',
      numeric: false,
      disablePadding: true,
      label: 'Parachute Size',
      width: "150px"
    },
    {
      id: 'classes',
      numeric: false,
      disablePadding: true,
      label: 'Assigned Classes',
      width: "150px"
    },
    {
      id: 'createdAt',
      numeric: false,
      disablePadding: true,
      label: 'Uploaded on',
      width: "100px"
    },
  ];
  function EnhancedTableHead(props) {

    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
      props;

    const [iconShow, setIconShow] = useState(true);

    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    function showIcon() {
      setIconShow(true);

    }

    return (
      <TableHead >
        <TableRow className='mt-10'>
          {headCells.map((headCell) => (
            <TableCell
              key={headCell.id}
              align={'center'}
              padding={'normal'}
              sortDirection={orderBy === headCell.id ? order : false}
              sx={
                headCell.width
                  ? { width: headCell?.width, maxWidth: headCell?.maxWidth }
                  : {}
              }>
              <Tooltip title={headCell?.label === "VOW" ? "Volume of Water" : headCell?.label === "VOE" ? "Volume of Engine" : headCell?.label === 'RDM' ? 'Rocket Dry Mass' : headCell?.label} placement="top">
                <TableSortLabel
                  className={`sort-header btn-wh2`}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    minHeight: "40px",
                    display: "flex",
                    color: "#000000",
                    fontWeight: 500,
                    fontSize: 14,
                    lineHeight: "16.94px",
                    fontFamily: "Inter",
                  }}
                  active={orderBy === headCell.id && !iconShow}
                  direction={orderBy === headCell.id ? order : 'asc'}
                  onClick={createSortHandler(headCell.id)}
                  onMouseEnter={() => setIconShow(false)}
                  onMouseLeave={() => setIconShow(true)}
                >
                  <div className="text-Center fonted fontAdjust-700">{headCell.label}</div>
                </TableSortLabel>
              </Tooltip>
            </TableCell>
          ))}
          <TableCell sx={{
            width: "100px",
            fontFamily: 'Exo2-Regular' 
          }}
            align={'center'}
            padding={'normal'}>
            <span><div className='text-Center fonted fontAdjust-700 sort-header btn-wh2'>View</div></span>
          </TableCell>
          <TableCell sx={{
            width: "100px",
            fontFamily: 'Exo2-Regular' 
          }}
            align={'center'}
            padding={'normal'}>
            <span><div className='text-Center fonted fontAdjust-700 sort-header btn-wh2'>Action</div></span>
          </TableCell>
        </TableRow>
      </TableHead>
    );
  }

  EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };

  const EnhancedTableToolbar = (props) => {
    const { numSelected } = props;
    return (
      <div className='pt-10'>
      </div>
    );
  };

  EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
  };
  const handleChangePage = (event, newPage) => {
    setPaged(event.selected);
    getLaunchData(myUser, event.selected, pageLimit, orderBy, order);
    history.push({
      pathname: '/launchtrakfiles',
      search: `?${(serial) ? `serial=${serial}&` : ''}` + 'page=' + event.selected + '&limit=' + pageLimit + '&orderBy=' + orderBy + '&order=' + order
    })
  };

  const onSetOrder = (event, property) => {
    let orderTemp = order === 'asc' ? 'desc' : 'asc';
    let urlPage = parseInt(params.get('page'));
    let urlLimit = parseInt(params.get('limit'));
    let urlSerial = params.get('serial')
    history.push({
      pathname: '/launchtrakfiles',
      search: `?${(urlSerial) ? `serial=${urlSerial}&` : ''}` + 'page=' + urlPage + '&limit=' + urlLimit + '&orderBy=' + property + '&order=' + orderTemp
    })
    getLaunchData(myUser, urlPage, urlLimit, property, orderTemp, true);
    setPaged(urlPage);
    setSerial(urlSerial);
    setPageLimit(urlLimit);
    setOrder(orderTemp);
    setOrderBy(property);
  }
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = deviceInfo.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };
  const getClasses = async () => {
    const _cookie = getCookie('recoil-persist')
    const user = _cookie ? JSON.parse(_cookie)['teacher_v1'] : {}
    let res = await getAllClassbyTeacher(user?.token);
    setallclasses(res?.res?.data?.data?.sclass);
  };

  // RESET ALL STATES
  function reset() {
    setCheckedFiles([]);
    setMetaArr([]);
    setOpen(false);
    setFileNames([]);
    setScanLoading(false);
    setTempArray([])
    setNoFiles(false);
    setDeviceData([
      {
        name: "",
        pressure: 0,
        volumeOfWater: 0,
        volumeOfEngine: 0,
        nozzleSize: 0,
        rocketDryMass: 0,
        parachuteSize: 0,
        noParachut: false,
        decentSpeed: 0,
        topSpeed: 0,
        totalFlightTime: 0,
        apogeeAltitude: 0,
        apogeeTime: 0,
        coastTime: 0,
      },
    ]);
  }
  // Connect to a new device
  async function connectSerial() {
    try {
      port = await navigator.serial.requestPort();
      await port.open({ baudRate: 115200 });
      let settings = {};
      settings.dataTerminalReady = true;
      settings.requestToSend = true;
      if (Object.keys(settings)?.length > 0) await port.setSignals(settings);
      // eslint-disable-next-line no-undef
      textEncoder = new TextEncoderStream();
      writableStreamClosed = textEncoder.readable.pipeTo(port.writable);
      writer = textEncoder.writable.getWriter();
      setOpen(true);
      getClasses();
      await listenToPort();
    } catch (e) {
      feedBackMsg(true, "warning", "Serial Connection Failed " + e);
      reset();

    }
  }
  // listening to launchtrak device for ouput
  async function listenToPort() {
    // eslint-disable-next-line no-undef
    const textDecoder = new TextDecoderStream();
    readableStreamClosed = port?.readable?.pipeTo(textDecoder?.writable);
    reader = textDecoder?.readable?.getReader();
    let buffer = "";
    try {
      let allfiles = [];
      while (true) {
        const { value, done } = await reader.read();
        console.log("value, done ....", value, done)
        if (done) {
          // reader.releaseLock();
          break;
        }

        if (currentCommand == "L") {
          await delay(1000);
          const fileArray = value.split(" ");
          // console.log(fileArray,"spiltttt");

          fileArray?.forEach(function (item) {
            if (item.startsWith("ltk")) {
              let temp = item?.split(".")[0];
              if (!allfiles?.includes(temp)) {
                allfiles.push(temp);
              }
              // filenames.push(value);
            }
          });

          setFileNames([...allfiles]);
        }
        if (currentCommand == "B") {
          // Every dump starts and ends with a "@\n" line, ignore it
          console.log("current commond", currentCommand, value, "BBBBB");
          if (value.startsWith("@")) {
            if (startedDumpingFile) {
              // subject.next();
              currentCommand = "P";
              await sendCommand("P");
            }
            // await delay(2000);

            startedDumpingFile = !startedDumpingFile;
          } else if (startedDumpingFile) {
            dumpedData += value;
          }
        }
        // PROCESS FOR GET VALUE OF INTEREST FROM DEVICE
        if (currentCommand === "P") {
          valuesOfInterest.push(value);
          buffer = buffer + value;
          if (buffer.includes("Impact Accel:")) {
            buffer = "";
            subject.next();
          }
          console.log(value, "pppppp");
        }
        // PROCESS FOR DELETE FILES FROM DEVICE 
        if (currentCommand == "E") {
          if (value.includes("[Y/n]")) {
            await sendCommand("Y");
          }
          if (value.includes("Done")) {
            subject.next();
          }
        }
      }
    }
    catch (e) {
      feedBackMsg(true, "warning", "Serial Connection Failed " + e);
      reset();
    }
    finally {
      reader.releaseLock();
    }
  }
  async function sendCommand(command) {
    try {
      command += "\r";
      await writer?.write(command);
      if (command?.trim()?.startsWith("\x03")) {
        // eslint-disable-next-line no-undef
        echo(false);
      }
    } catch (error) {
      feedBackMsg(true, "warning", "Serial Connection Failed " + error);
      reset();
    }
  }
  // Asks the LaunchTrak device for the list of files using the "L" command
  async function getFilenames() {
    // setLoadings(true);
    currentCommand = "L";
    await sendCommand("L");
  }

  // Ask launchtrak to erase file with the "E" command
  async function deleteFilesFromDevice() {
    return new Promise(async (resolve, reject) => {
      currentCommand = "E";
      await sendCommand("E");
      const a = subject.subscribe((data) => {
        a.unsubscribe();
        resolve("done");
      });
    });
  }
  // Ask launchtrak to open file with the "B" command
  async function viewFileData() {
    return new Promise(async (resolve, reject) => {
      currentCommand = "B";
      await sendCommand("B");
      console.log("after call B")
      await delay(3000);
      openFile();
      await delay(3000);
      dumpFile();
      // await delay(3000);
      // currentCommand = "P";
      // await sendCommand("P");
      const a = subject.subscribe((data) => {
        let dataArray = dumpedData.split("\n");
        const _data = createDataArray(dataArray);
        dumpedData = "";
        currentCommand = "";
        a.unsubscribe()
        resolve(_data);
      });
    });
  }

  // After asking launchtrak to open file, send it a command "[filename]" where [filename] is the file you want to open
  async function openFile() {
    // The command ignores the ltk part of the filename so just give numbers (characters 3 to 5)
    await sendCommand(localStorage.filename.substring(3, 6));
  }

  // Once a file is opened, dump the data with "H" command
  async function dumpFile() {
    await sendCommand("H");
  }
  // Simple delay
  function delay(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }
  async function disconnectFromSerial() {
    try {
      // Cancel the reader
      if (reader) {
        await reader.cancel();
        reader.releaseLock();
      }
      // Close the readable stream
      if (readableStreamClosed) {
        await readableStreamClosed.catch(() => { });
      }
      // Close the writer
      if (writer) {
        await writer.close();
        await writableStreamClosed;
      }
      // Close the port
      if (port) {
        await port.close();
      }
    } catch (error) {
      feedBackMsg(true, "warning", "Serial Connection Failed " + error);
      reset();
    }
  }


const filterPressureSpike = async (data) => {
  let graphData = [...data];
  if (!graphData || graphData === 0) return [];

  //If the first pressure value is greater than 1,000,000 then replace with second pressure value.
  if (
    graphData.length > 1 &&
    graphData[0].press !== undefined &&
    graphData[0].press >= 1000000 &&
    graphData[1] &&
    graphData[1].press !== undefined
  ) {
    graphData[0].press = graphData[1].press;
  }

  // If current pressure is greater than 10 X previous pressure then replace current with previous.
  for (let i = 1; i < graphData.length; i++) {
    if (
      graphData[i].press !== undefined &&
      graphData[i - 1].press !== undefined &&
      graphData[i].press >= graphData[i - 1].press * 10
    ) {
      graphData[i].press = graphData[i - 1].press;
    }
  }
  return graphData;
};
  // Using the raw data from the LaunchTrak, split it up according to all the values (time, roll, pitch, etc)

  async function createDataArray(dataArray) {
    let graphData = [];
    let initialAltitude = 0;
    let validLinesSoFar = 0;
    let startThrustTime = 0;
    let endThrustTime = 0;
    let startedThrust = false;
    let endedThrust = false;
    let thrustTime = 0;
    let previousTime = 0.0;
    let previousAcceleration = 0.0;
    let prevAX = 0.0;
    let prevAY = 0.0;
    let prevAZ = 0.0;
    let velocity = 0.0;
    let prevVX = 0.0; //added code
    let prevVY = 0.0; //added code
    let prevVZ = 0.0; //added code
    let coastTime = 0.0;
    let maxAltitude = 0;
    let maxAltitudeTime = 0;
    let maxThrust = 0;
    let avgThrust = 0;
    let avgThrustCount = 0;
    let maxHighGAcceleration = 0;
    let endOfFlightTime = 0;
    
    // First, create an array of raw data points
    let rawDataPoints = [];
    
    for (let i = 0; i < dataArray?.length - 5; i++) {
      let lineArray = dataArray[i]?.split(",");
      if (lineArray?.length > 11) {
        if (lineArray[0]?.match(/^\d/)) {
          rawDataPoints.push({
            time: lineArray[0] / 1000000,
            roll: Number(lineArray[1]),
            pitch: Number(lineArray[2]),
            yaw: Number(lineArray[3]),
            ax: Number(lineArray[4]),
            ay: Number(lineArray[5]),
            az: Number(lineArray[6]),
            press: Number(lineArray[7]),
            temp: Number(lineArray[8]),
            hgx: Number(lineArray[9]),
            hgy: Number(lineArray[10]),
            hgz: Number(lineArray[11])
          });
        }
      }
    }
  
    // Filter pressure spikes BEFORE calculating altitude
    const filteredDataPoints = await filterPressureSpike(rawDataPoints);
    
    // Now process filtered data and calculate altitude and other metrics
    for (let i = 0; i < filteredDataPoints.length; i++) {
      const point = filteredDataPoints[i];
      
      // Convert time to seconds
      let current_time = point.time;
      
      // HERE CALCULATION OF ACCELERATION
      // Acceleration = sqrt(ax^2 + ay^2 + az^2)
      let x = point.ax;
      let y = point.ay;
      let z = point.az;
      let accel = Math.sqrt(x * x + y * y + z * z);
      
      // HERE CALCULATION OF VELOCITY
      // Velocity
      let deltaTime = current_time - previousTime;
      let deltaVX = deltaTime * ((prevAX + x) / 2.0);
      let deltaVY = deltaTime * ((prevAY + y) / 2.0);
      let deltaVZ = deltaTime * ((prevAZ + z) / 2.0);
      let vx = prevVX + deltaVX;
      let vy = prevVY + deltaVY;
      let vz = prevVZ + deltaVZ;
      velocity = Math.sqrt(vx * vx + (vy * vy) + vz * vz); // Fixed parenthesis issue
      
      // Altitude - using the filtered pressure data
      let seaLevelPressure = 101325.0;
      let pressure = point.press;
      let temperature = point.temp;
      let altitude =
        ((Math.pow(seaLevelPressure / pressure, 1.0 / 5.257) - 1.0) *
          (temperature + 273.15)) /
        0.0065;
      if (validLinesSoFar == 0) {
        initialAltitude = altitude;
      }
      altitude -= initialAltitude;
  
      // Thrust Time
      if (accel > 15.0 && !startedThrust) {
        startThrustTime = current_time;
        startedThrust = true;
      }
      if (startedThrust && !endedThrust) {
        if (Math.abs(accel) > maxThrust) {
          maxThrust = Math.abs(accel);
        }
        avgThrust = avgThrust + Math.abs(accel);
        avgThrustCount = avgThrustCount + 1;
        if (accel < 9.8) {
          endThrustTime = current_time;
          endedThrust = true;
          thrustTime = endThrustTime - startThrustTime;
          avgThrust = avgThrust / avgThrustCount;
        }
      }
      if (thrustTime > 0) {
        if (altitude > maxAltitude) {
          maxAltitude = altitude;
          maxAltitudeTime = current_time;
        }
      }
  
      // Max High G Accel Magnitude
      let hgx = point.hgx;
      let hgy = point.hgy;
      let hgz = point.hgz;
      let highGAcceleration = Math.sqrt(hgx * hgx + hgy * hgy + hgz * hgz);
      if (highGAcceleration > maxHighGAcceleration) {
        maxHighGAcceleration = highGAcceleration;
        endOfFlightTime = current_time;
      }
      
      graphData.push({
        time: point.time,
        roll: point.roll,
        pitch: point.pitch,
        yaw: point.yaw,
        ax: point.ax,
        ay: point.ay,
        az: point.az,
        press: point.press,
        temp: point.temp,
        hgx: point.hgx,
        hgy: point.hgy,
        hgz: point.hgz,
        acc: accel,
        vel: velocity,
        altitude: altitude,
        highGAcceleration: highGAcceleration,
      });
  
      validLinesSoFar = validLinesSoFar + 1;
      previousAcceleration = accel;
      prevAX = x;
      prevAY = y;
      prevAZ = z;
      prevVX = vx;
      prevVY = vy;
      prevVZ = vz;
      previousTime = current_time;
    }
    
    // Update Values of Interest
    // HERE CALCULATION OF VALUE OF INTEREST
    const combinedString = valuesOfInterest
      .join("") // Join array into a single string
      .replace(/\r\n|\t/g, "") // Remove carriage returns and tabs
      .replace(/Processing data in \w+\.bin/g, "");
    
    // Split the string into key-value pairs
    const keyValuePairs = combinedString
      .split(/(?<=\))(?=[A-Za-z])/)
      .map((pair) => pair.split(":"));
    
    // Create an object from the key-value pairs
    const resultObject = keyValuePairs.reduce((acc, [key, value]) => {
      if (key && value) {
        acc[key.trim()] = value.trim();
      }
      return acc;
    }, {});
    
    valuesOfInterest = [];
    const parseValue = (value) => parseFloat(value?.split(" ")[0]);
    coastTime =
      parseValue(resultObject["Apogee Time"]) -
      parseValue(resultObject["Thrust Time"]);
    resultObject.coastTime = `${coastTime} (s)`;
    dumpedData = "";
    currentCommand = "";
    
    console.log(graphData,"graphData");
    
    return {
      valuesOfInterest: resultObject,
      graphData: graphData, // Already filtered data
    };
    // Finished with data, generate graphs
  }

  const SnackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    feedBackMsg(false, '', '');
  }
  const getLaunchData = async (user = myUser, page, pageLimit, orderBy, order, orderFlag) => {
    if (orderFlag !== true) { setLoading(true); }
    let res = await getLaunchTrekData(user?.token, page, pageLimit, orderBy, order);
    if (res?.error) {
      if (res?.data?.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res?.data?.msg);
      }
    } else {
      setDeviceInfo(res?.res?.data?.result);
      let divisor = parseInt(res?.res?.data?.totalPages / pageLimit);
      let remainder = parseInt((res?.res?.data?.totalPages % pageLimit == 0) ? 0 : 1);
      setNoOfPages(divisor + remainder)
      setCurrPage(page);
      setLoading(false);
    }
  };
  function handleClickEdit(data) {
    getClasses();
    setEditOpen(true);
    setFileId(data?._id);
    setMetaData({
      name: data?.name,
      pressure: data?.pressure,
      volumeOfWater: data?.volumeOfWater,
      volumeOfEngine: data?.volumeOfEngine,
      nozzleSize: data?.nozzleSize,
      rocketDryMass: data?.rocketDryMass,
      parachuteSize: data?.parachuteSize,
      noParachut: data?.noParachut,
    })
    let tempId = []
    let clsName = []
    data?.cls?.map((data) => { tempId.push(data?._id); clsName.push(data?.name) })
    setSelectedClassIds(tempId)
    setSelectedClassNames(clsName)
    setallclasses([])
  }
  function handleClickDel(id) {
    setFileId(id);
    setDeleteOpen(true);

  }
  useEffect(() => {
    const _cookie = getCookie('recoil-persist')
    const user = _cookie ? JSON.parse(_cookie)['teacher_v1'] : {}
    setmyUser({ ...user, 'page': "device" });
    props.page('launchtrakfiles')
    let urlPage = parseInt(params.get('page'));
    let urlLimit = parseInt(params.get('limit'));
    let urlOrderBy = parseInt(params.get('orderBy'));
    let urlOrder = parseInt(params.get('order'));
    let urlSerial = params.get('serial')
    if (parseInt(params.get('page')) || parseInt(params.get('limit'))) {
      history.push({
        pathname: '/launchtrakfiles',
        search: `?${(urlSerial) ? `serial=${urlSerial}&` : ''}` + 'page=' + urlPage + '&limit=' + urlLimit + '&orderBy=' + urlOrderBy + '&order=' + urlOrder
      })
      getLaunchData(user, urlPage, urlLimit, urlOrderBy, urlOrder);
      setPaged(urlPage);
      setSerial(urlSerial);
      setPageLimit(urlLimit);
    } else {
      history.push({
        pathname: '/launchtrakfiles',
        search: `?${(urlSerial) ? `serial=${urlSerial}&` : ''}` + `page=0&limit=25&orderBy=${orderBy}&order=${order}`
      })
      getLaunchData(user, 0, pageLimit, orderBy, order)
    }
  }, [])
  const logoutHandler = async () => {
    setTimeout(() => {
      // setmyUser({
      //   fName: null,
      //   userId: null,
      //   token: null,
      //   lName: null,
      // })
      setTeacherCookie({
        fName: null,
        userId: null,
        token: null,
        lName: null,
      })
      let hostname = window.location.host;
      window.location.assign(`${window.location.protocol}//${hostname}/teachers`)
    })
  }

  return (
    <div style={{ height: "100vh", overflow: "hidden" }}>
      <main style={{ position: "absolute",  width: "100%", top: "20%" }}>
        <div className="container flex flex-col px-4 pt-3" >
          <div className="upper-section px-60 ">
            <div className='d-flex justify-content-between h-[10vh]' >
              <div>
                <div className="breadcrumb-menu py-2">
                  <Link to={'/'}>Teacher Panel </Link><i className="fas fa-angle-double-right"></i><a className='disable'>LaunchTrak Files</a>
                </div>
                <div className="text-blue maintext"><h2 className='h2'>LaunchTrak Files</h2></div>
                <div className="">
                  <div className="">
                    <div className="card-header px-0"><h3 className='h3'>View LaunchTrak Files here</h3></div>
                  </div>

                </div>
              </div>
              {/* BUTTON TO CONNECT THE DEVICE */}
              <div className="d-flex justify-content-end">
                <button className="teacher-scan-button" onClick={(e) => connectSerial(e)}>
                  <img src={add} alt="scan" width={25} />
                  <span className="teacher-scan-btn-span">Select device</span>
                </button>
              </div>
            </div>

            {/* <br/> */}
            {deviceInfo?.length > 0 &&
              <div style={{ overflow: "hidden" }}>

                <ReactPaginate
                  previousLabel="Previous"
                  nextLabel="Next"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakLabel="..."
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  pageCount={noOfPages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={handleChangePage}
                  containerClassName="pagination"
                  activeClassName="activePage active"
                  forcePage={currPage} />

              </div>
            }
          </div>
          {console.log(fileNames, "filenames")}
          <Box  className='flex-1 bg-red h-[10vh]' >
            <div className=" px-3">
              <div className="row table-section experiments ">
                <div className="lower-section px-4 pt-3 mb-2 w-100">
                  <Box sx={{ width: "100%" }}>
                    {loading ?
                      <Paper
                       sx={{
                        mb: 2, backgroundColor: 'transparent', border: 'none', boxShadow: 'none', display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}>
                        <CircularProgress />
                      </Paper>
                      :
                      deviceInfo?.length ?
                        <Paper sx={{ width: "100%", mb: 2 }}>
                          <EnhancedTableToolbar numSelected={selected?.length} />
                          <TableContainer
                            sx={{
                              maxHeight: "calc(100vh - 250px)",
                              overflow: "auto",
                              height: "52vh",
                              width: "100%",
                            }}>
                            <Table
                              sx={{
                                tableLayout: "fixed",
                                minWidth: { xs: 300, sm: 500, md: 750 },
                              }}
                              aria-labelledby="tableTitle"
                              size={"small"}
                              stickyHeader
                            >
                              <EnhancedTableHead
                                numSelected={selected?.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={handleSelectAllClick}
                                onRequestSort={onSetOrder}
                                rowCount={deviceInfo?.length}
                              />
                              <TableBody className="table-body fonted noBor">
                                {deviceInfo
                                  .map((data, index) => {
                                    return (
                                      <TableRow
                                        hover
                                        role="checkbox"
                                        // aria-checked={isItemSelected}
                                        tabIndex={-1}
                                      // key={experiments.name}
                                      >
                                        <TableCell align="center" sx={{ cursor: 'pointer', fontFamily: 'Exo2-Regular', fontSize: 'medium' }} className="text-truncate" data-toggle="tooltip" data-placement="top" title={data?.name}>
                                          {data?.name}
                                        </TableCell>
                                        <TableCell align="center" sx={{ cursor: 'pointer', fontFamily: 'Exo2-Regular', fontSize: 'medium' }} className="text-truncate" data-toggle="tooltip" data-placement="top" title={data?.name}>
                                          {data?.originalName}
                                        </TableCell>
                                        <TableCell className="fitted" align="center" sx={{ fontFamily: 'Exo2-Regular', fontSize: '14px' }} >
                                          {data?.pressure ?
                                            data?.pressure?.toFixed(2) + " " + 'PSI' :
                                            '--'
                                          }
                                        </TableCell>

                                        <TableCell className="fitted" align="center" sx={{ fontFamily: 'Exo2-Regular', fontSize: '14px' }}>
                                          {data?.volumeOfWater ?
                                            data?.volumeOfWater?.toFixed(2) + " " + 'ml' :
                                            '--'
                                          }
                                        </TableCell>

                                        <TableCell className="fitted" align="center" sx={{ fontFamily: 'Exo2-Regular', fontSize: '14px' }}>
                                          {data?.volumeOfEngine ?
                                            data?.volumeOfEngine?.toFixed(2) + " " + 'ml' :
                                            '--'
                                          }
                                        </TableCell>
                                        <TableCell align="center" sx={{ fontFamily: 'Exo2-Regular', fontSize: 'medium' }}>
                                          {data?.nozzleSize ?
                                            data?.nozzleSize?.toFixed(2) + " " + 'mm' :
                                            '--'
                                          }
                                        </TableCell>
                                        <TableCell align="center" sx={{ fontFamily: 'Exo2-Regular', fontSize: 'medium' }}>
                                          {data?.rocketDryMass ?
                                            data?.rocketDryMass?.toFixed(2) + " " + 'g' :
                                            '--'
                                          }
                                        </TableCell>
                                        <TableCell align="center" sx={{ fontFamily: 'Exo2-Regular', fontSize: 'medium' }}>
                                          {data?.noParachut ?
                                            "No Parachut"
                                            : data?.parachuteSize ?
                                              data?.parachuteSize?.toFixed(2) + " " + 'm²' :
                                              '--'
                                          }
                                        </TableCell>
                                        <TableCell align="center" sx={{ fontFamily: 'Exo2-Regular', fontSize: 'medium' }}>
                                          {data?.cls?.length ? (
                                            data?.cls?.length > 2 ? (
                                              <div style={{ whiteSpace: "nowrap" }}>
                                                <span
                                                  style={{
                                                    width: 60,
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                  }}
                                                >
                                                  {data?.cls[0]?.name +
                                                    " , " +
                                                    data?.cls[1]?.name}
                                                </span>
                                                <Tooltip
                                                  title={data?.cls?.slice(2)
                                                    ?.map((obj) => obj.name
                                                    )
                                                    .join(", ")}
                                                >
                                                  <span style={{ cursor: 'pointer', color: '#348BE3', fontWeight: 500, fontSize: 20 }}>
                                                    {" +" + (data?.cls?.length - 2)}
                                                  </span>
                                                </Tooltip>
                                              </div>
                                            ) : (
                                              // data?.cls?.map((item) => item?.name)
                                              <div style={{ whiteSpace: "nowrap" }}>
                                                <span
                                                  style={{
                                                    width: 60,
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                  }}
                                                >
                                                  {data?.cls[0]?.name && data?.cls[1]?.name ? data?.cls[0]?.name + " , " + data?.cls[1]?.name : data?.cls[0]?.name}
                                                </span>
                                              </div>
                                            )
                                          ) : (
                                            <Typography
                                              style={{
                                                color: "#E80000",
                                                fontWeight: 400,
                                                fontSize: 20,
                                              }}
                                            >
                                              Not assigned
                                            </Typography>
                                          )}
                                        </TableCell>
                                        <TableCell align="center" sx={{ fontFamily: 'Exo2-Regular', fontSize: 'medium' }}>
                                          {data?.createdAt?.split("T")[0]}
                                        </TableCell>
                                        <TableCell
                                          className="fitted"
                                        >
                                          <div className="d-flex class-btn justify-content-center">
                                            <div className="btn-wh1 text-center d-flex align-items-center py-0">
                                              <div className="pt-1 pb-0 d-flex align-items-center p-2">
                                                <Link
                                                  to={{
                                                    pathname: `/launchtrakfiles/${data?._id}}`,
                                                    state: {
                                                      id: data?._id,
                                                      fileName: data?.name || data?.originalName
                                                    }
                                                  }}
                                                  style={{
                                                    fontFamily: "Exo2-Regular",
                                                    fontSize: "medium",
                                                    color: "#000000",
                                                    fontWeight: 500,
                                                    fontSize: 14,
                                                    fontFamily: "Inter",
                                                    lineHeight: '16.96px'
                                                  }}
                                                >
                                                  View
                                                </Link>
                                              </div>
                                            </div>
                                          </div>
                                        </TableCell>
                                        <TableCell align="center" className='class-btn fonted d-flex justify-content-center mt-3'>
                                          <div className="px-1">
                                            <Tooltip title="Edit" placement="top">
                                              <Link onClick={(e) => {
                                                e.stopPropagation();
                                                handleClickEdit(data);
                                              }}>
                                                <img src={Group_332} className="ps-3" style={{ width: '25.24px', height: '25.24px' }} />
                                              </Link>
                                            </Tooltip>
                                          </div>
                                          <div className="px-1">
                                            <Tooltip title="Delete" placement="top">
                                              <Link onClick={(e) => {
                                                e.stopPropagation();
                                                handleClickDel(data?._id);
                                              }}>
                                                <img src={Group_299} className="ps-3" style={{ width: '25.24px', height: '25.24px' }} />
                                              </Link>
                                            </Tooltip>
                                          </div>


                                        </TableCell>
                                      </TableRow>
                                    );
                                  })}
                                {emptyRows > 0 && (
                                  <TableRow
                                    style={{
                                      height: (dense ? 33 : 53) * emptyRows,
                                    }}
                                  >
                                    <TableCell colSpan={6} />
                                  </TableRow>
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Paper>
                        :
                        <Box
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <img src={notFound} alt="notFound" width={600} />
                          <p
                            style={{
                              fontFamily: "Inter",
                              fontSize: 48,
                              color: "#348BE3",
                            }}
                          >
                            No files found!
                          </p>
                          <span
                            style={{
                              fontFamily: "Inter",
                              fontWeight: 400,
                              fontSize: 23,
                              color: "#82B6FF",
                            }}
                          >
                            There are currently no files available. Please check back later
                          </span>
                        </Box>
                    }
                    <Snackbar
                      open={snackBarShow}
                      autoHideDuration={3000}
                      onClose={SnackClose}
                    >
                      <Alert
                        onClose={SnackClose}
                        severity={snackBarSeverity}
                        sx={{ width: "100%" }}
                      >
                        {snackBarMessage}
                      </Alert>
                    </Snackbar>
                  </Box>
                </div>
              </div>
            </div>
          </Box>

        </div>
        <EditFile
          open={editOpen}
          setOpen={setEditOpen}
          fileId={fileId}
          edit={true}
          getLaunchData={getLaunchData}
          metaData={metaData}
          setMetaData={setMetaData}
          page={page}
          pageLimit={pageLimit}
          allClasses={allClasses}
          setallclasses={setallclasses}
          selectedClassIds={selectedClassIds}
          setSelectedClassIds={setSelectedClassIds}
          selectedClassNames={selectedClassNames}
          setSelectedClassNames={setSelectedClassNames}
          setSnackBarShow={setSnackBarShow}
          setSnackBarMessage={setSnackBarMessage}
          setSnackBarSeverity={setSnackBarSeverity}
        />
        <DeleteFiles
          open={deleteOpen}
          setOpen={setDeleteOpen}
          fileId={fileId}
          getLaunchData={getLaunchData}
          page={parseInt(params.get("page")) || 0}
          pageLimit={parseInt(params.get("limit")) || pageLimit}
          orderBy={parseInt(params.get('orderBy')) || 'createdAt'}
          order={parseInt(params.get('order')) || 'desc'}
          setSnackBarShow={setSnackBarShow}
          setSnackBarMessage={setSnackBarMessage}
          setSnackBarSeverity={setSnackBarSeverity}
          moduleDel='deleteFromDatabase'
        />
        <ScanDevice
          open={open}
          setOpen={setOpen}
          fileNames={fileNames}
          setFileNames={setFileNames}
          viewFileData={viewFileData}
          listenToPort={listenToPort}
          getFilenames={getFilenames}
          deviceData={deviceData}
          setDeviceData={setDeviceData}
          setSnackBarShow={setSnackBarShow}
          setSnackBarMessage={setSnackBarMessage}
          setSnackBarSeverity={setSnackBarSeverity}
          getLaunchData={getLaunchData}
          metaData={metaData}
          setMetaData={setMetaData}
          page={page}
          pageLimit={pageLimit}
          allClasses={allClasses}
          setallclasses={setallclasses}
          selectedClassIds={selectedClassIds}
          setSelectedClassIds={setSelectedClassIds}
          selectedClassNames={selectedClassNames}
          setSelectedClassNames={setSelectedClassNames}
          deleteFilesFromDevice={deleteFilesFromDevice}
          disconnectFromSerial={disconnectFromSerial}
          delay={delay}
          scanLoading={scanLoading}
          setScanLoading={setScanLoading}
          checkedFiles={checkedFiles}
          setCheckedFiles={setCheckedFiles}
          metaArr={metaArr}
          setMetaArr={setMetaArr}
          noFiles={noFiles}
          setNoFiles={setNoFiles}
          tempArray={tempArray}
          setTempArray={setTempArray}
        />
      </main>
    </div>
  )
}
